// ============================================
// Role Constants — matches PHP roles table
// ============================================

export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  TEACHER: 'teacher',
  ACCOUNTANT: 'accountant',
  LIBRARIAN: 'librarian',
  RECEPTIONIST: 'receptionist',
  STUDENT: 'student',
  PARENT: 'parent',
} as const;

/** 
 * Well-known roles allowed to access the Admin portal.
 * NOTE: This is NOT exhaustive — custom roles (e.g., "Computer Operator", "HOD")
 * created in the DB are also valid admin roles. Do NOT use this for access control.
 * Use isStaffRole() instead.
 */
export const ADMIN_ROLES = [
  ROLES.SUPERADMIN,
  'super admin',  // DB stores role as "Super Admin" → JWT as "super admin"
  ROLES.ADMIN,
  ROLES.TEACHER,
  ROLES.ACCOUNTANT,
  ROLES.LIBRARIAN,
  ROLES.RECEPTIONIST,
] as const;

/** Roles allowed to access the User portal */
export const USER_ROLES = [
  ROLES.STUDENT,
  ROLES.PARENT,
] as const;

/** Check if a role is a staff/admin role (not student/parent) */
export function isStaffRole(role: string): boolean {
  const userOnly = ['student', 'parent'];
  return !userOnly.includes(role.toLowerCase());
}
